import { cubicEaseOut } from '@helpers/animate';
import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import { Layers } from '@helpers/layers';
import styled from 'styled-components';
const Container = styled.nav `
  --fgColor: ${brand.grey.grey6};
  --bgColor: ${brand.white};

  position: fixed;
  top: var(--headerHeight);
  left: 0;
  display: flex;
  flex-direction: column;
  background: var(--bgColor);
  color: var(--fgColor);
  height: calc(100% - var(--headerHeight));
  opacity: 0;
  overflow-y: auto;
  padding: 0 18px;
  pointer-events: none;
  transition: opacity 0.15s ${cubicEaseOut};
  width: 100%;
  z-index: ${Layers.Header};

  &[data-m-active='true'] {
    opacity: 1;
    pointer-events: all;
  }
`;
const List = styled.ul `
  padding: 32px 0;
`;
const Item = styled.li `
  &:not(:last-child) {
    margin-bottom: 32px;
  }
`;
const Link = styled.a `
  display: flex;
  align-items: center;
  color: currentColor;
  ${fonts.helvetica.bold};
  font-size: 18px;
  letter-spacing: -0.01em;
  line-height: 1em;
  text-decoration: none;

  &:focus,
  &:hover {
    color: ${brand.blue.base};
    text-decoration: underline;
    text-underline-position: under;
  }
`;
const Text = styled.span ``;
const Arrow = styled.span `
  margin-left: auto;
`;
const Header = styled.header `
  padding: 24px 0;
  border-bottom: 1px solid ${brand.grey.grey3};
`;
const Back = styled.button `
  display: flex;
  align-items: center;
  background: none;
  border: 0;
  ${fonts.helvetica.regular};
  font-size: 14px;
  line-height: 1em;
  margin: 0 0 16px;
  padding: 0;

  > svg {
    margin-right: 12px;
  }
`;
const Current = styled(Link) `
  color: ${brand.blue.base};
  text-decoration: underline;
  text-underline-position: under;
`;
const SmallList = styled(List) `
  padding: 32px 0;
`;
const SmallItem = styled(Item) ``;
const SmallLink = styled(Link) `
  color: ${brand.grey.grey3};
  ${fonts.helvetica.bold};
  font-size: 16px;
`;
const Divider = styled.hr `
  display: block;
  border: 0;
  border-bottom: 1px solid ${brand.grey.grey3};
  width: 100%;
`;
const MobileNavigationStyles = {
    Arrow,
    Back,
    Container,
    Current,
    Divider,
    Header,
    Item,
    Link,
    List,
    SmallItem,
    SmallLink,
    SmallList,
    Text,
};
export default MobileNavigationStyles;
